import { gql } from '@apollo/client';
import { WarehouseLocationScanResponse } from '../queries/warehouseQueries';

export const HANDLE_PICKING_SCAN_EVENT = gql`
  mutation HandlePickingScanEvent($trackingNumber: String!) {
    handlePickingScanEvent(trackingNumber: $trackingNumber) {
      success
      messageKey
      requireConfirmation
      packageInfo {
        locationId
        locationNo
        trackingNumber
        locationOrderNo
        nextAction
        pickingActionDetail
      }
    }
  }
`;

export interface HandlePickingScanEventResponse {
  handlePickingScanEvent: WarehouseLocationScanResponse;
}

export interface HandlePickingScanEventVariables {
  trackingNumber: string;
}
